// import React from 'react';
// import { Table, Badge, Pagination, Spinner } from 'react-bootstrap';

// const EscalationsTable = ({
//   escalations,
//   loading,
//   page,
//   totalPages,
//   onPageChange
// }) => {
//   const renderPaginationItems = () => {
//     const items = [];
//     const startPage = Math.max(2, page - 2);
//     const endPage = Math.min(totalPages - 1, page + 2);

//     // Always show first page
//     items.push(
//       <Pagination.Item
//         key={1}
//         active={page === 1}
//         onClick={() => onPageChange(1)}
//       >
//         1
//       </Pagination.Item>
//     );

//     // Ellipsis before startPage
//     if (startPage > 2) {
//       items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
//     }

//     // Middle range
//     for (let i = startPage; i <= endPage; i++) {
//       items.push(
//         <Pagination.Item
//           key={i}
//           active={page === i}
//           onClick={() => onPageChange(i)}
//         >
//           {i}
//         </Pagination.Item>
//       );
//     }

//     // Ellipsis after endPage
//     if (endPage < totalPages - 1) {
//       items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
//     }

//     // Always show last page
//     if (totalPages > 1) {
//       items.push(
//         <Pagination.Item
//           key={totalPages}
//           active={page === totalPages}
//           onClick={() => onPageChange(totalPages)}
//         >
//           {totalPages}
//         </Pagination.Item>
//       );
//     }

//     return items;
//   };

//   return (
//     <div>
//       <h5 className="mb-2">Escalations (Flagged Applicants)</h5>
//       {loading ? (
//         <Spinner size="sm" animation="border" />
//       ) : escalations.length === 0 ? (
//         <div className="text-center text-muted">No flagged applicants on this page.</div>
//       ) : (
//         <Table responsive striped hover size="sm">
//           <thead>
//             <tr>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Phone</th>
//               <th>Reminder Count</th>
//               <th>Status</th>
//             </tr>
//           </thead>
//           <tbody>
//             {escalations.map((a, idx) => (
//               <tr key={idx}>
//                 <td>{a.first_name} {a.last_name}</td>
//                 <td>{a.email_id}</td>
//                 <td>{a.phone_number}</td>
//                 <td>{a.reminder_count}</td>
//                 <td>
//                   {a.flagged ? (
//                     <Badge bg="danger">Flagged</Badge>
//                   ) : (
//                     <Badge bg="secondary">Pending</Badge>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </Table>
//       )}
//       <div className="d-flex justify-content-center mt-3">
//         <Pagination>
//           <Pagination.First onClick={() => onPageChange(1)} disabled={page === 1} />
//           <Pagination.Prev onClick={() => onPageChange(page - 1)} disabled={page === 1} />
//           {renderPaginationItems()}
//           <Pagination.Next onClick={() => onPageChange(page + 1)} disabled={page === totalPages} />
//           <Pagination.Last onClick={() => onPageChange(totalPages)} disabled={page === totalPages} />
//         </Pagination>
//       </div>
//     </div>
//   );
// };

// export default EscalationsTable;

// -----------------------------------------------------------------------------------------------

import React from 'react';
import { Table, Badge, Pagination, Spinner } from 'react-bootstrap';

const EscalationsTable = ({
  escalations,
  loading,
  page,
  totalPages,
  onPageChange
}) => {
  const renderPaginationItems = () => {
    const items = [];
    const startPage = Math.max(2, page - 2);
    const endPage = Math.min(totalPages - 1, page + 2);

    // Always show first page
    items.push(
      <Pagination.Item
        key={1}
        active={page === 1}
        onClick={() => onPageChange(1)}
      >
        1
      </Pagination.Item>
    );

    // Ellipsis before startPage
    if (startPage > 2) {
      items.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
    }

    // Middle range
    for (let i = startPage; i <= endPage; i++) {
      items.push(
        <Pagination.Item
          key={i}
          active={page === i}
          onClick={() => onPageChange(i)}
        >
          {i}
        </Pagination.Item>
      );
    }

    // Ellipsis after endPage
    if (endPage < totalPages - 1) {
      items.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
    }

    // Always show last page
    if (totalPages > 1) {
      items.push(
        <Pagination.Item
          key={totalPages}
          active={page === totalPages}
          onClick={() => onPageChange(totalPages)}
        >
          {totalPages}
        </Pagination.Item>
      );
    }

    return items;
  };

  return (
    <div>
      <h5 className="mb-2">Escalations (Flagged Applicants)</h5>
      {loading ? (
        <Spinner size="sm" animation="border" />
      ) : escalations.length === 0 ? (
        <div className="text-center text-muted">No flagged applicants on this page.</div>
      ) : (
        <Table responsive striped hover size="sm">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Reminder Count</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {escalations.map((a, idx) => (
              <tr key={idx}>
                <td>{a.first_name} {a.last_name}</td>
                <td>{a.email_id}</td>
                <td>{a.phone_number}</td>
                <td>{a.reminder_count}</td>
                <td>
                  {a.flagged ? (
                    <Badge bg="danger">Flagged</Badge>
                  ) : (
                    <Badge bg="secondary">Pending</Badge>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
      <div className="d-flex justify-content-center mt-3">
        <Pagination>
          <Pagination.First onClick={() => onPageChange(1)} disabled={page === 1} />
          <Pagination.Prev onClick={() => onPageChange(page - 1)} disabled={page === 1} />
          {renderPaginationItems()}
          <Pagination.Next onClick={() => onPageChange(page + 1)} disabled={page === totalPages} />
          <Pagination.Last onClick={() => onPageChange(totalPages)} disabled={page === totalPages} />
        </Pagination>
      </div>
    </div>
  );
};

export default EscalationsTable;
